// extracted by mini-css-extract-plugin
export default {"container":"LB-z","modal":"MB-z","dimensions":"NB-z","brandName":"OB-z","productName":"PB-z","labelValue":"QB-z","recipientEmail":"RB-z","recommendedFit":"SB-z","hiddenField":"TB-z"};